import { useEffect, useMemo, useState } from "react"
import { MainContainer } from "../../components"
import { usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useDispatch, useSelector } from "react-redux"
import { calculateTotalByKey, selectFilter } from "../../Utility/utility"
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { parse } from "@fortawesome/fontawesome-svg-core"
import { useNavigate, } from "react-router-dom"
import { setDetailLotno } from "../../state/stockEntrySlice"
import { toast } from "react-toastify"



const LotWisePositionReport = () => {
    const { compCode } = useSelector((state) => state.company)
    const { detailLotNo } = useSelector((state) => state.stockEntry);
    const [selectedLots, setSelectedLots] = useState([]);
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { data = [], isPending: isPendingData, mutate: filterData } = usePost({
        url: apiRoute.stockEntry.fetchLotWiseReport,
        queryKey: "lotwiseDatastck",
        onSuccessTasks: (data) => {
        }
    })

    useEffect(() => {
        filterData({
            data: {
                comp_code: compCode.join(","),
                trade_of: "P"
            }
        })
    }, [])
    const formatNum = (num) => typeof num === 'number' ? num.toFixed(2) : num;
    const formatWeightNum = (num) => typeof num === 'number' ? num.toFixed(3) : num;
    // const data = [ /* your array here */ ];
    const summarizedData = useMemo(() => {
        const summary = {};
        data.forEach(item => {
            const code = item.L_Code || "NA"; // use "NA" for empty L_Code
            if (!summary[code]) {
                summary[code] = {
                    L_Code: code,
                    InMixPcs: 0,
                    InMixWt: 0,
                    InMixRate: 0,
                    InMixDRate: 0,
                    InSinglePcs: 0,
                    InSingleWt: 0,
                    InSingleRate: 0,
                    InSingleDRate: 0,
                    SaleMixPcs: 0,
                    SaleMixWt: 0,
                    SaleMixRate: 0,
                    SaleMixDRate: 0,
                    SaleSinglePcs: 0,
                    SaleSingleWt: 0,
                    SaleSingleRate: 0,
                    SaleSingleDRate: 0,
                    // StockMixPcs: 0,
                    // StockMixWt: 0,
                    // StockMixRate: 0,
                    StockSinglePcs: 0,
                    StockSingleWt: 0,
                    StockSingleRate: 0,
                    StockSingleDRate: 0,
                };
            }

            const entry = summary[code];
            switch (item.Type) {
                case "Inward Mix":
                    entry.InMixPcs += item.Nos;
                    entry.InMixWt += item.Weight;
                    entry.InMixRate += item.Rate;
                    entry.InMixDRate += item.S_Rate;
                    break;
                case "Inward Single":
                    entry.InSinglePcs += item.Nos;
                    entry.InSingleWt += item.Weight;
                    entry.InSingleRate += item.Rate;
                    entry.InSingleDRate += item.S_Rate;
                    break;
                case "Sale Mix":
                    entry.SaleMixPcs += item.Nos;
                    entry.SaleMixWt += item.Weight;
                    entry.SaleMixRate += item.Rate;
                    entry.SaleMixDRate += item.S_Rate;
                    break;
                case "Sale Single":
                    entry.SaleSinglePcs += item.Nos;
                    entry.SaleSingleWt += item.Weight;
                    entry.SaleSingleRate += item.Rate;
                    entry.SaleSingleDRate += item.S_Rate;
                    break;
                // case "Stock Mix":
                //     entry.StockMixPcs += item.Nos;
                //     entry.StockMixWt += item.Weight;
                //     entry.StockMixRate += item.Rate;
                //     break;
                case "Stock Single":
                    entry.StockSinglePcs += item.Nos;
                    entry.StockSingleWt += item.Weight;
                    entry.StockSingleRate += item.Rate;
                    entry.StockSingleDRate += item.S_Rate;
                    break;
                default:
                    break;
            }
        });
        return Object.values(summary);
        // Convert to array format (optional)
        // const result = Object.values(summary);
        // console.log(result);


    }, [data])


    const grandTotal = useMemo(() => {
        return summarizedData.reduce((tot, row) => {
            tot.InMixPcs += row.InMixPcs;
            tot.InMixWt += parseFloat(row.InMixWt.toFixed(2));
            tot.InMixRate += row.InMixRate;
            tot.InMixDRate += row.InMixDRate;

            tot.InSinglePcs += row.InSinglePcs;
            tot.InSingleWt += parseFloat(row.InSingleWt.toFixed(2));
            tot.InSingleRate += row.InSingleRate;
            tot.InSingleDRate += row.InSingleDRate;

            tot.SaleMixPcs += row.SaleMixPcs;
            tot.SaleMixWt += row.SaleMixWt;
            tot.SaleMixRate += row.SaleMixRate;
            tot.SaleMixDRate += row.SaleMixDRate;

            tot.SaleSinglePcs += row.SaleSinglePcs;
            tot.SaleSingleWt += parseFloat(row.SaleSingleWt.toFixed(2));
            tot.SaleSingleRate += row.SaleSingleRate;
            tot.SaleSingleDRate += row.SaleSingleDRate;

            tot.StockSinglePcs += row.StockSinglePcs;
            tot.StockSingleWt += parseFloat(row.StockSingleWt.toFixed(2));
            tot.StockSingleRate += row.StockSingleRate;
            tot.StockSingleDRate += row.StockSingleDRate;

            return tot;
        }, {
            InMixPcs: 0, InMixWt: 0, InMixRate: 0, InMixDRate: 0,
            InSinglePcs: 0, InSingleWt: 0, InSingleRate: 0, InSingleDRate: 0,
            SaleMixPcs: 0, SaleMixWt: 0, SaleMixRate: 0, SaleMixDRate: 0,
            SaleSinglePcs: 0, SaleSingleWt: 0, SaleSingleRate: 0, SaleSingleDRate: 0,
            StockSinglePcs: 0, StockSingleWt: 0, StockSingleRate: 0, StockSingleDRate: 0,
        });
    }, [summarizedData]);
    const gt_stkMixPcs = grandTotal.InMixPcs - grandTotal.SaleMixPcs;
    const gt_stkMixWt = grandTotal.InMixWt - grandTotal.SaleMixWt;

    const gt_stkSinglePcs = grandTotal.InSinglePcs - grandTotal.SaleSinglePcs;
    const gt_stkSingleWt = grandTotal.InSingleWt - grandTotal.SaleSingleWt;

    const gt_totalPcs = gt_stkMixPcs + gt_stkSinglePcs;
    const gt_totalWt = gt_stkMixWt + gt_stkSingleWt;


    /* ================== STYLES ================== */

    const border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" }
    };

    const headerStyle = {
        font: { bold: true },
        alignment: { horizontal: "center", vertical: "center" },
        border
    };

    const inwardStyle = {
        fill: { fgColor: { rgb: "DCFCE7" } },
        alignment: { horizontal: "center" },
        border
    };

    const saleStyle = {
        fill: { fgColor: { rgb: "DBEAFE" } },
        alignment: { horizontal: "center" },
        border
    };

    const stockStyle = {
        fill: { fgColor: { rgb: "FEE2E2" } },
        alignment: { horizontal: "center" },
        border
    };

    const totalStyle = {
        font: { bold: true },
        fill: { fgColor: { rgb: "F3F4F6" } },
        alignment: { horizontal: "center" },
        border
    };

    /* ================== EXPORT ================== */
   
    const exportLotWisePositionExcel = (
        summarizedData,
        grandTotal,
        fileName = "Lot_Wise_Position_Report"
    ) => {
        if (!summarizedData?.length) return;

        /* ================= HEADERS ================= */

        const header1 = [
            "Lot No",
            "Inward Mix", "", "", "",
            "Inward Single", "", "", "",
            "Total", "", "", "",
            "Sale Mix", "", "", "",
            "Sale Single", "", "", "",
            "Total", "", "", "",
            "Stock Mix", "", "", "",
            "Stock Single", "", "", "",
            "Total", "", "", ""
        ];

        const header2 = [
            "",
            ...Array(9).fill(["Pcs", "Weight", "Rate", "Rate($)"]).flat()
        ];

        /* ================= DATA ================= */

        const body = summarizedData.map(r => {
            const smp = r.InMixPcs - r.SaleMixPcs;
            const smw = r.InMixWt - r.SaleMixWt;
            const ssp = r.InSinglePcs - r.SaleSinglePcs;
            const ssw = r.InSingleWt - r.SaleSingleWt;

            return [
                r.L_Code,

                // Inward Mix
                r.InMixPcs, r.InMixWt, r.InMixRate, r.InMixDRate,

                // Inward Single
                r.InSinglePcs, r.InSingleWt, r.InSingleRate, r.InSingleDRate,

                // Inward Total
                r.InMixPcs + r.InSinglePcs,
                r.InMixWt + r.InSingleWt,
                r.InMixRate + r.InSingleRate,
                r.InMixDRate + r.InSingleDRate,

                // Sale Mix
                r.SaleMixPcs, r.SaleMixWt, r.SaleMixRate, r.SaleMixDRate,

                // Sale Single
                r.SaleSinglePcs, r.SaleSingleWt, r.SaleSingleRate, r.SaleSingleDRate,

                // Sale Total
                r.SaleMixPcs + r.SaleSinglePcs,
                r.SaleMixWt + r.SaleSingleWt,
                r.SaleMixRate + r.SaleSingleRate,
                r.SaleMixDRate + r.SaleSingleDRate,

                // Stock Mix
                smp, smw,
                smw <= 0 ? 0 : r.InMixRate,
                smw <= 0 ? 0 : r.InMixDRate,

                // Stock Single
                ssp, ssw,
                ssw <= 0 ? 0 : r.InSingleRate,
                ssw <= 0 ? 0 : r.InSingleDRate,

                // Stock Total
                smp + ssp,
                smw + ssw,
                smw + ssw <= 0 ? 0 : r.InMixRate + r.InSingleRate,
                smw + ssw <= 0 ? 0 : r.InMixDRate + r.InSingleDRate
            ];
        });

        /* ================= GRAND TOTAL ================= */
        console.log(body)
        body.push([
            "TOTAL",

            grandTotal.InMixPcs, grandTotal.InMixWt, grandTotal.InMixRate, grandTotal.InMixDRate,
            grandTotal.InSinglePcs, grandTotal.InSingleWt, grandTotal.InSingleRate, grandTotal.InSingleDRate,

            grandTotal.InMixPcs + grandTotal.InSinglePcs,
            grandTotal.InMixWt + grandTotal.InSingleWt,
            grandTotal.InMixRate + grandTotal.InSingleRate,
            grandTotal.InMixDRate + grandTotal.InSingleDRate,

            grandTotal.SaleMixPcs, grandTotal.SaleMixWt, grandTotal.SaleMixRate, grandTotal.SaleMixDRate,
            grandTotal.SaleSinglePcs, grandTotal.SaleSingleWt, grandTotal.SaleSingleRate, grandTotal.SaleSingleDRate,

            grandTotal.SaleMixPcs + grandTotal.SaleSinglePcs,
            grandTotal.SaleMixWt + grandTotal.SaleSingleWt,
            grandTotal.SaleMixRate + grandTotal.SaleSingleRate,
            grandTotal.SaleMixDRate + grandTotal.SaleSingleDRate,

            grandTotal.InMixPcs - grandTotal.SaleMixPcs,
            grandTotal.InMixWt - grandTotal.SaleMixWt,
            "",
            "",

            grandTotal.InSinglePcs - grandTotal.SaleSinglePcs,
            grandTotal.InSingleWt - grandTotal.SaleSingleWt,
            grandTotal.StockSingleRate,
            grandTotal.StockSingleDRate,

            (grandTotal.InMixPcs - grandTotal.SaleMixPcs) + grandTotal.InSinglePcs - grandTotal.SaleSinglePcs,
            (grandTotal.InMixWt - grandTotal.SaleMixWt) + (grandTotal.InSingleWt - grandTotal.SaleSingleWt),
            grandTotal.StockSingleRate,
            grandTotal.StockSingleDRate,
        ]);

        const ws = XLSX.utils.aoa_to_sheet([header1, header2, ...body]);

        /* ================= MERGES ================= */

        ws["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
            ...[1, 5, 9, 13, 17, 21, 25, 29, 33].map(c => ({
                s: { r: 0, c },
                e: { r: 0, c: c + 3 }
            }))
        ];

        /* ================= STYLES & FORMATS ================= */

        Object.keys(ws).forEach(cell => {
            if (cell.startsWith("!")) return;

            const { r, c } = XLSX.utils.decode_cell(cell);

            if (r <= 1) ws[cell].s = headerStyle;
            else if (r === body.length + 1) ws[cell].s = totalStyle;
            else if ([1, 2, 3, 4, 17, 18, 19, 20].includes(c)) ws[cell].s = inwardStyle;
            else if ([5, 6, 7, 8, 21, 22, 23, 24].includes(c)) ws[cell].s = saleStyle;
            else ws[cell].s = stockStyle;

            // Weight
            if ([2, 6, 10, 14, 18, 22, 26, 30, 34].includes(c))
                ws[cell].z = "0.000";

            // Rate & Rate($)
            if ([
                3, 4, 7, 8, 11, 12,
                15, 16, 19, 20,
                23, 24, 27, 28,
                31, 32, 35, 36
            ].includes(c))
                ws[cell].z = "0.00";
        });

        /* ================= EXCEL SETTINGS ================= */

        ws["!cols"] = [{ wch: 10 }, ...Array(36).fill({ wch: 12 })];

        ws["!freeze"] = { xSplit: 1, ySplit: 2 };
        ws["!autofilter"] = { ref: `A2:AK${body.length + 2}` };

        ws["!pageSetup"] = {
            paper: 8,
            orientation: "landscape",
            scale: 90,
            fitToWidth: 1
        };

        ws["!printTitles"] = { rows: "1:2", cols: "A:A" };

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Lot Wise Position");

        const buffer = XLSX.write(wb, {
            bookType: "xlsx",
            type: "array",
            cellStyles: true
        });

        saveAs(
            new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }),
            `${fileName}.xlsx`
        );
    };
    const handleLotSelect = (lotCode) => {
        setSelectedLots((prev) => {
            if (prev.includes(lotCode)) {
                // unselect
                return prev.filter(code => code !== lotCode);
            } else {
                // select
                return [...prev, lotCode];
            }
        });
    };
    const handleLotDetail = () => {
        if (selectedLots && selectedLots.length > 0) {
            dispatch(setDetailLotno(selectedLots))
            navigate(linksUrl.rptLotwiseDetail)
        }
        else {
            toast.error("select Lot No To show Detail", {
                "position": "top-center"
            })
        }
    }


    //const summary = {};

    //const StickyClass = ' sticky left-0  pr-2  border-orange-300 bg-gradient-to-r from-orange-100 to-orange-50 z-10'
    const thStyle = "border-1 uppercase text-xs bg-slate-50 border-gray-500 p-2  text-center font-semibold";

    const tdStyle = "border-1  border-gray-400 text-center p-1 ";

    const rowEvenStyle = "bg-white";

    const rowOddStyle = "bg-gray-100";
    const InColor = " bg-green-100  text-green-500"
    const SaleColor = " bg-blue-100 text-blue-500"
    const StockColor = " bg-red-100   text-red-500"
    const StickyHeaderClass = "sticky top-0   bg-slate-50  z-20";
    const StickyLeftCell = "sticky left-0 border-r-2  bg-gradient-to-r from-orange-100 to-orange-50 z-10";
    const bgWhite = " bg-white "
    return (
        <div>
            <MainContainer pageName="Lot Wise Position " info={[]}
                breadcrumbs={["Reports", "Lot Wise Position"]}

            >
                {summarizedData && summarizedData.length > 0 ?
                    <div className="mx-1 py-5 ">
                        <div className="flex justify-between mb-2 ">

                            {/* <button
                                onClick={handleLotDetail}
                                className="bg-blue-600 text-white px-3 py-1 rounded text-sm"
                            >
                                Lot Detail
                            </button> */}
                            <div className="flex gap-4">
                                <button
                                    onClick={() =>
                                        exportLotWisePositionExcel(
                                            summarizedData,
                                            grandTotal,
                                            "Lot_Wise_Position"
                                        )
                                    }
                                    className="bg-green-600 text-white px-3 py-1 rounded text-sm"
                                >
                                    Export Excel
                                </button>
                                <h2 className="text-orange-500 font-semibold text-sm">Total Records:{summarizedData.length}</h2>
                            </div>
                        </div>


                        <div className={` w-full h-96 bg-white overflow-scroll`}>
                            <table className="text-sm text-center">
                                <thead>
                                    <tr>
                                        <th className={`${thStyle} sticky top-0 left-0 border-r-2 bg-gradient-to-r from-orange-100 to-orange-50 z-40`} rowSpan="3">Lot_No.</th>
                                        <th className={`${thStyle} ${StickyHeaderClass} ${InColor}`} colSpan="4">Inward Mix</th>
                                        <th className={`${thStyle} ${StickyHeaderClass} ${SaleColor}`} colSpan="4">Inward Single</th>
                                        <th className={`${thStyle} ${StickyHeaderClass} ${StockColor}`} colSpan="4">Total</th>
                                        <th className={`${thStyle} ${StickyHeaderClass} ${InColor}`} colSpan="4">Sale Mix</th>
                                        <th className={`${thStyle} ${StickyHeaderClass} ${SaleColor}`} colSpan="4">Sale Single</th>
                                        <th className={`${thStyle} ${StickyHeaderClass} ${StockColor}`} colSpan="4">Total</th>
                                        <th className={`${thStyle} ${StickyHeaderClass} ${InColor}`} colSpan="4">Stock Mix</th>
                                        <th className={`${thStyle} ${StickyHeaderClass} ${SaleColor}`} colSpan="4">Stock Single</th>
                                        <th className={`${thStyle} ${StickyHeaderClass} ${StockColor}`} colSpan="4">Total</th>
                                    </tr>
                                    <tr className="">
                                        {[
                                            InColor, InColor, InColor, InColor,
                                            SaleColor, SaleColor, SaleColor, SaleColor,
                                            StockColor, StockColor, StockColor, StockColor,
                                            InColor, InColor, InColor, InColor,
                                            SaleColor, SaleColor, SaleColor, SaleColor,
                                            StockColor, StockColor, StockColor, StockColor,
                                            InColor, InColor, InColor, InColor,
                                            SaleColor, SaleColor, SaleColor, SaleColor,
                                            StockColor, StockColor, StockColor, StockColor,
                                        ].map((colorClass, i) => (
                                            <th key={i} className={`${thStyle} sticky   top-7 border-t-2 bg-slate-50 z-10 ${colorClass}`}>
                                                {["Pcs", "Weight", "Rate", "Rate($)"][i % 4]}
                                            </th>
                                        ))}

                                    </tr>
                                </thead>
                                <tbody>
                                    {summarizedData.map((row, idx) => {
                                        const t_stkMixPcs = row.InMixPcs - row.SaleMixPcs
                                        const t_stkMixwt = Math.round(row.InMixWt) - Math.round(row.SaleMixWt)
                                        const t_stkPcs = row.InSinglePcs - row.SaleSinglePcs
                                        const t_stkwt = Math.round(row.InSingleWt) - Math.round(row.SaleSingleWt)
                                        const t_totalPcs = t_stkMixPcs + t_stkPcs
                                        const t_totalWt = t_stkMixwt + t_stkwt
                                        const t_stkMixRate = row.InMixRate
                                        //const t_stkSingleRate = row.InSingleRate
                                        const t_stkSingleRate = row.StockSingleRate
                                        const t_stkMixDRate = row.InMixDRate
                                        //const t_stkSingleDRate = row.InSingleDRate
                                        const t_stkSingleDRate = row.StockSingleDRate

                                        return (
                                            <tr key={idx} className={`${idx % 2 == 0 ? rowEvenStyle : rowOddStyle}`}>
                                                <td className={`${tdStyle} ${StickyLeftCell}`}>
                                                    
                                                    {row.L_Code}</td>
                                                <td className={tdStyle + InColor}>{row.InMixPcs}</td>
                                                <td className={tdStyle + InColor}>{formatWeightNum(row.InMixWt)}</td>
                                                <td className={tdStyle + InColor}>{formatNum(row.InMixRate)}</td>
                                                <td className={tdStyle + InColor}>{formatNum(row.InMixDRate)}</td>
                                                <td className={tdStyle + SaleColor}>{row.InSinglePcs}</td>
                                                <td className={tdStyle + SaleColor}>{formatWeightNum(row.InSingleWt)}</td>
                                                <td className={tdStyle + SaleColor}>{formatNum(row.InSingleRate)}</td>
                                                <td className={tdStyle + SaleColor}>{formatNum(row.InSingleDRate)}</td>
                                                <td className={tdStyle + StockColor}>{row.InMixPcs + row.InSinglePcs}</td>
                                                <td className={tdStyle + StockColor}>{formatWeightNum(row.InMixWt + row.InSingleWt)}</td>
                                                <td className={tdStyle + StockColor}>{formatNum(row.InMixRate + row.InSingleRate)}</td>
                                                <td className={tdStyle + StockColor}>{formatNum(row.InMixDRate + row.InSingleDRate)}</td>
                                                <td className={tdStyle + InColor}>{row.SaleMixPcs}</td>
                                                <td className={tdStyle + InColor}>{formatWeightNum(row.SaleMixWt)}</td>
                                                <td className={tdStyle + InColor}>{formatNum(row.SaleMixRate)}</td>
                                                <td className={tdStyle + InColor}>{formatNum(row.SaleMixDRate)}</td>
                                                <td className={tdStyle + SaleColor}>{row.SaleSinglePcs}</td>
                                                <td className={tdStyle + SaleColor}>{formatWeightNum(row.SaleSingleWt)}</td>
                                                <td className={tdStyle + SaleColor}>{formatNum(row.SaleSingleRate)}</td>
                                                <td className={tdStyle + SaleColor}>{formatNum(row.SaleSingleDRate)}</td>
                                                <td className={tdStyle + StockColor}>{row.SaleMixPcs + row.SaleSinglePcs}</td>
                                                <td className={tdStyle + StockColor}>{formatWeightNum(row.SaleMixWt + row.SaleSingleWt)}</td>
                                                <td className={tdStyle + StockColor}>{formatNum(row.SaleMixRate + row.SaleSingleRate)}</td>
                                                <td className={tdStyle + StockColor}>{formatNum(row.SaleMixDRate + row.SaleSingleDRate)}</td>
                                                <td className={tdStyle + InColor}>{t_stkMixPcs}</td>
                                                <td className={tdStyle + InColor}>{formatWeightNum(t_stkMixwt)}</td>
                                                <td className={tdStyle + InColor}>{formatNum(t_stkMixwt <= 0 ? 0 : t_stkMixRate)}</td>
                                                <td className={tdStyle + InColor}>{formatNum(t_stkMixwt <= 0 ? 0 : t_stkMixDRate)}</td>
                                                <td className={tdStyle + SaleColor}>{t_stkPcs}</td>
                                                <td className={tdStyle + SaleColor}>{formatWeightNum(t_stkwt)}</td>
                                                <td className={tdStyle + SaleColor}>{formatNum(t_stkwt <= 0 ? 0 : t_stkSingleRate)}</td>
                                                <td className={tdStyle + SaleColor}>{formatNum(t_stkwt <= 0 ? 0 : t_stkSingleDRate)}</td>
                                                <td className={tdStyle + StockColor}>{t_totalPcs}</td>
                                                <td className={tdStyle + StockColor}>{formatWeightNum(t_totalWt)}</td>
                                                <td className={tdStyle + StockColor}>{formatNum(t_totalWt <= 0 ? 0 : t_stkMixRate + t_stkSingleRate)}</td>
                                                <td className={tdStyle + StockColor}>{formatNum(t_totalWt <= 0 ? 0 : t_stkMixDRate + t_stkSingleDRate)}</td>
                                            </tr>
                                        )
                                    })}
                                    <tr className="font-bold  h-12 bg-white sticky bottom-0 z-20">
                                        <td className={`${tdStyle} ${StickyLeftCell}`}>TOTAL</td>

                                        <td className={`${tdStyle + InColor + bgWhite} `}>{grandTotal.InMixPcs}</td>
                                        <td className={`${tdStyle + InColor + bgWhite} `}>{formatWeightNum(grandTotal.InMixWt)}</td>
                                        <td className={`${tdStyle + InColor + bgWhite} `}>{formatNum(grandTotal.InMixRate)}</td>
                                        <td className={`${tdStyle + InColor + bgWhite} `}>{formatNum(grandTotal.InMixDRate)}</td>


                                        <td className={`${tdStyle + SaleColor + bgWhite}`}>{grandTotal.InSinglePcs}</td>
                                        <td className={`${tdStyle + SaleColor + bgWhite} `}>{formatWeightNum(grandTotal.InSingleWt)}</td>
                                        <td className={`${tdStyle + SaleColor + bgWhite} `}>{formatNum(grandTotal.InSingleRate)}</td>
                                        <td className={`${tdStyle + SaleColor + bgWhite} `}>{formatNum(grandTotal.InSingleDRate)}</td>

                                        <td className={tdStyle + StockColor + bgWhite}>
                                            {grandTotal.InMixPcs + grandTotal.InSinglePcs}
                                        </td>
                                        <td className={tdStyle + StockColor + bgWhite}>
                                            {formatWeightNum(grandTotal.InMixWt + grandTotal.InSingleWt)}
                                        </td>
                                        <td className={tdStyle + StockColor + bgWhite}>
                                            {formatNum(grandTotal.InMixRate + grandTotal.InSingleRate)}
                                        </td>
                                        <td className={tdStyle + StockColor + bgWhite}>
                                            {formatNum(grandTotal.InMixDRate + grandTotal.InSingleDRate)}
                                        </td>

                                        <td className={tdStyle + InColor + bgWhite}>{grandTotal.SaleMixPcs}</td>
                                        <td className={tdStyle + InColor + bgWhite}>{formatWeightNum(grandTotal.SaleMixWt)}</td>
                                        <td className={tdStyle + InColor + bgWhite}>{formatNum(grandTotal.SaleMixRate)}</td>
                                        <td className={tdStyle + InColor + bgWhite}>{formatNum(grandTotal.SaleMixDRate)}</td>


                                        <td className={tdStyle + SaleColor + bgWhite}>{grandTotal.SaleSinglePcs}</td>
                                        <td className={tdStyle + SaleColor + bgWhite}>{formatWeightNum(grandTotal.SaleSingleWt)}</td>
                                        <td className={tdStyle + SaleColor + bgWhite}>{formatNum(grandTotal.SaleSingleRate)}</td>
                                        <td className={tdStyle + SaleColor + bgWhite}>{formatNum(grandTotal.SaleSingleDRate)}</td>

                                        <td className={tdStyle + StockColor + bgWhite}>
                                            {grandTotal.SaleMixPcs + grandTotal.SaleSinglePcs}
                                        </td>
                                        <td className={tdStyle + StockColor + bgWhite}>
                                            {formatWeightNum(grandTotal.SaleMixWt + grandTotal.SaleSingleWt)}
                                        </td>
                                        <td className={tdStyle + StockColor + bgWhite}>
                                            {formatNum(grandTotal.SaleMixRate + grandTotal.SaleSingleRate)}
                                        </td>
                                        <td className={tdStyle + StockColor + bgWhite}>
                                            {formatNum(grandTotal.SaleMixDRate + grandTotal.SaleSingleDRate)}
                                        </td>

                                        <td className={tdStyle + InColor + bgWhite}>{gt_stkMixPcs}</td>
                                        <td className={tdStyle + InColor + bgWhite}>{formatWeightNum(gt_stkMixWt)}</td>
                                        <td className={tdStyle + InColor + bgWhite}>{formatNum(gt_stkMixWt <= 0 ? 0 : grandTotal.InMixRate)}</td>
                                        <td className={tdStyle + InColor + bgWhite}>{formatNum(gt_stkMixWt <= 0 ? 0 : grandTotal.InMixDRate)}</td>

                                        <td className={tdStyle + SaleColor + bgWhite}>{gt_stkSinglePcs}</td>
                                        <td className={tdStyle + SaleColor + bgWhite}>{formatWeightNum(gt_stkSingleWt)}</td>
                                        <td className={tdStyle + SaleColor + bgWhite}>{formatNum(gt_stkSingleWt <= 0 ? 0 : grandTotal.StockSingleRate)}</td>
                                        <td className={tdStyle + SaleColor + bgWhite}>{formatNum(gt_stkSingleWt <= 0 ? 0 : grandTotal.StockSingleDRate)}</td>

                                        <td className={tdStyle + StockColor + bgWhite}>{gt_totalPcs}</td>
                                        <td className={tdStyle + StockColor + bgWhite}>{formatWeightNum(gt_totalWt)}</td>
                                        <td className={tdStyle + StockColor + bgWhite}>
                                            {formatNum(gt_totalWt <= 0 ? 0 : grandTotal.InMixRate + grandTotal.StockSingleRate)}
                                        </td>
                                        <td className={tdStyle + StockColor + bgWhite}>
                                            {formatNum(gt_totalWt <= 0 ? 0 : grandTotal.InMixDRate + grandTotal.StockSingleDRate)}
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                    : <h2 className="text-gray-400 p-5 text-sm text-center">No Records Found</h2>}
            </MainContainer>
        </div>
    )
}

export default LotWisePositionReport
{/*  <input
                                                    type="checkbox"
                                                    className="
    w-4 h-4     mr-2         
    text-indigo-600       
    bg-white               
    border border-gray-300 
    rounded               
    focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1
    transition duration-150
    cursor-pointer"
                                                    checked={selectedLots.includes(row.L_Code)}
                                                    onChange={() => handleLotSelect(row.L_Code)}
                                                /> */}